// extracted by mini-css-extract-plugin
export var dataCell = "_p5-2";
export var dataRow = "_p5-0";
export var headerRow = "_p5-1";